// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"8006d8ec","488":"3e77e67f","617":"52a13ee0","698":"7ddf7048","878":"a925b95c"}[chunkId] + ".chunk.js";
};